<template>
		<transition name="slide-fade">
				<div class="alert alert-dismissible hh-alert" :class="alertClass + ' ' + position" role="alert" v-if="show">
						<button type="button" class="close hh-alert-close-icon" name="Close" data-dismiss="alert" aria-label="Close">
								<span aria-hidden="true">&times;</span>
						</button>
						<p class="hh-alert-text">
								{{message}}
						</p>
				</div>
		</transition>
</template>

<script>
	export default {
		name: 'Alert',

		props: {
			type: String,
			message: String,
			position: {
				default: 'p-abs',
				type: String
			}
		},

		data: () => {
			return {
				defaultAlertClass: 'alert-success',
				show: true,
			}
		},

		mounted() {
			setTimeout(() => {
				this.show = false
			}, 3000);

			setTimeout(() => {
				this.$emit('hideAlert')
			}, 4000);
		},

    methods: {
      reactivate() {
        this.show = true
      },
    },

    computed: {
			alertClass() {
				if (_.isEmpty(this.type)) {
					return this.defaultAlertClass
				}

				return this.type
			}
		},

		watch: {},


	}
</script>

<style scoped>
		.slide-fade-enter-active {
				transition: all .4s ease;
		}
		.slide-fade-leave-active {
				transition: all 1s cubic-bezier(1.0, 0.5, 0.8, 1.0);
		}
		.slide-fade-enter, .slide-fade-leave-to
				/* .slide-fade-leave-active below version 2.1.8 */ {
				transform: translateY(-10px);
				opacity: 0;
		}
</style>